import { FaAngleLeft } from 'react-icons/fa6';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LogoCrest from '../../assets/img/logo-crest.png';
import { MdOutlineArrowCircleLeft } from 'react-icons/md';

const ComingSoon = () => {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  
  // Set launch date to 30 days from now
  useEffect(() => {
    const launchDate = new Date();
    launchDate.setDate(launchDate.getDate() + 30);
    
    const timer = setInterval(() => {
      const now = new Date();
      const difference = launchDate.getTime() - now.getTime();
      
      if (difference <= 0) {
        clearInterval(timer);
        return;
      }
      
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      setCountdown({ days, hours, minutes, seconds });
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);
  
  return (
    <section className='main p-2 coming-soon-section'>
      <div className="container-fluid p-0">
        <div className="d-flex align-items-center mb-1">
          <button onClick={() => window.history.back()} className="btn btn-sm" style={{ color: '#777' }}>
            <FaAngleLeft size={15} />
            <span className="ms-1 small mt-1">Go back</span>
          </button>
        </div>
        
        <div className="text-center coming-soon-container" style={{ padding: '3rem 1rem', backgroundColor: '#DAEFFF', height: '100vh' }}>
          {/* <Link to="/dashboard" className='d-flex align-items-center justify-content-center gap-2 mb-4'>
            <img src={LogoCrest} alt="Cardplot Logo" className='icon__sidebar-show' width="60px" height="60px"/>
            <h2 className='fs-1 fw-bold m-0'>Cardplot</h2>
          </Link> */}
          
          <div className="coming-soon-content mt-4">
            <h1 className="display-4 fw-bold" style={{ color: '#333' }}>Coming Soon</h1>
            <p className="lead mb-4" style={{ color: '#666' }}>
              We are working on something amazing! Stay tuned. 🚀 <br/>
              We'll notify you when it's ready!
            </p>
            
            {/* <div className="countdown-container d-flex justify-content-center gap-4 mb-5">
              <div className="countdown-item text-center">
                <div className="countdown-value" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#007bff' }}>
                  {countdown.days}
                </div>
                <div className="countdown-label" style={{ color: '#666' }}>Days</div>
              </div>
              <div className="countdown-item text-center">
                <div className="countdown-value" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#007bff' }}>
                  {countdown.hours}
                </div>
                <div className="countdown-label" style={{ color: '#666' }}>Hours</div>
              </div>
              <div className="countdown-item text-center">
                <div className="countdown-value" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#007bff' }}>
                  {countdown.minutes}
                </div>
                <div className="countdown-label" style={{ color: '#666' }}>Minutes</div>
              </div>
              <div className="countdown-item text-center">
                <div className="countdown-value" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#007bff' }}>
                  {countdown.seconds}
                </div>
                <div className="countdown-label" style={{ color: '#666' }}>Seconds</div>
              </div>
            </div> */}
            
            <Link to="/user/dashboard" className='btn primary__btn' style={{width: 'fit-content', margin: 'auto'}}>
                <MdOutlineArrowCircleLeft size={25} />
                <span>Back To Dashboard</span>
            </Link>
            
            {/* <div className="social-icons mt-4">
              <div className="d-flex justify-content-center gap-3">
                <a href="#" className="text-decoration-none" style={{ color: '#007bff' }}>
                  <i className="fab fa-twitter fa-lg"></i>
                </a>
                <a href="#" className="text-decoration-none" style={{ color: '#007bff' }}>
                  <i className="fab fa-facebook fa-lg"></i>
                </a>
                <a href="#" className="text-decoration-none" style={{ color: '#007bff' }}>
                  <i className="fab fa-instagram fa-lg"></i>
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;